import React, { Component } from 'react';

const autoBind = require('auto-bind');

class ShowCard extends React.Component {

    constructor(props) {
        super(props);
        autoBind(this);
    }

    componentDidMount() {
    }
 
    render() {
        let cardContent = [];
        if (this.props.cards) {

            for (var cardIndex = 0; cardIndex < this.props.cards.length; cardIndex++) {
                let card = this.props.cards[cardIndex]
                cardContent.push(
                    <div key={card.token + '-' + cardIndex.toString()} className="alexa-card-wrapper">
                        <div className="alexa-card-title">
                            {card.mainTitle}
                        </div>
                        <div className="alexa-card-subtitle">
                            {card.subTitle}
                        </div>
                        <div className="alexa-card-textfield">
                            {card.textField}
                        </div>
                    </div>
                )
            }

        }
        return (
             <div className="alexa-content alexa-flex-column-center" style={{ width:'100% '}}>
                    <div className="cards-content" style={{width: '600px'}}>
                        {cardContent}
                    </div>

            </div>
        );
    }
}

export default ShowCard;